import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@src/store';

const UpsertMissionReducer = (state: RootState) => state.UpsertMissionReducer;
const UpsertMissionState = createSelector([UpsertMissionReducer], (state) => state);

export const selectWaypoints = createSelector([UpsertMissionState], (state) => state.waypoints);
export const selectDrone = createSelector([UpsertMissionState], (state) => state.selectedDrone);
export const selectActiveStep = createSelector([UpsertMissionState], (state) => state.activeStep);
export const selectExpandedStep = createSelector([UpsertMissionState], (state) => state.expandedStep);
export const selectWizardOrderId = createSelector([UpsertMissionState], (state) => state.wizardOrderId);
export const selectHoveredDrone = createSelector([UpsertMissionState], (state) => state.hoveredDrone);
export const selectEditableRoute = createSelector([UpsertMissionState], (state) => state.editableRoute);
export const selectRouteModified = createSelector([UpsertMissionState], (state) => state.routeModified);
export const selectTerrainMode = createSelector([UpsertMissionState], (state) => state.terrainMode);